import { transition } from 'd3-transition';
import { AttrTween } from './attrTween';

interface ClampAttribute {
  propertyName: 'width' | 'height';
  min: number;
}

/**
 * Array of attributes that should be clamped when a transition is taking place to avoid invalid values on SVG properties.
 */
const CLAMP_ATTRIUBTES: ClampAttribute[] = [
  {
    // Height can never be less than 0
    propertyName: 'height',
    min: 0,
  },
  {
    // Width can never be less than 0
    propertyName: 'width',
    min: 0,
  },
];

/**
 * Prevent invalid property values by clamping them according to the rules specified above.
 */
export function patchAttrTween() {
  transition.prototype.attrTween = AttrTween(CLAMP_ATTRIUBTES);
}
